const logos = require.context('./', false, /\.(jpg|png|svg)$/);
logos.keys().forEach(logos);
